import globalConfig from '../utiles/globalConfig'

export default {
  data() {
    return {
      dzgjpThirdPartyPaymentDownContent:
        `親愛なる【主人】様：\n\n日頃のご愛顧誠にありがとうございます。より安全な決済環境を提供するため、\n【2025年12月1日 17:00(日本時間)】に以下の決済システム調整を実施いたします：\n公式サイトのチャージプラットフォーム【および / PCでの決済機能 / ブラウザゲームの決済機能】のサービスを終了\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\n終了後は以下の公式チャネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\n注意事項\n1. 公式サイトのチャージクーポンの配布も同時に終了しますが、2025年12月1日 17:00(日本時間)までに受け取ったクーポンは有効期限まで使用可能です。\n2. 公式サイトのチャージプラットフォームで既にチャージしたゲーム内通貨やアイテムは引き続き通常通り使用できます。\n3. 一部の決済方法（コンビニ払い/クレジットカードなど）では入金に遅延が生じる場合があります。2025年12月1日 17:00(日本時間)までにチャージが反映されない場合（弊社で入金が確認できない場合）、そのチャージは自動的に無効となりますので、チャージのタイミングにご注意ください。\n\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\n\nご理解とご支援に重ねて感謝申し上げます。\n\n【商人放浪記 - あきんどの成り上がり道】運営チーム\n2025年11月24日`,
      dzgjpCouponDownContent:
        '親愛なるご主人様:\n\nプレミアムセンターの優待券配布戦略の評価に基づき、以下の調整を行うことになりました:\n\n2025年11月6日17:00 (utc+9) より、優待券の配布を停止いたします。\n\nなお、2025年11月6日17:00 (utc+9) 以前に受け取られた優待券は、その有効期限まで引き続きご利用いただけます。\n\nまた、プレミアムセンターのチャージ任務は、以下の公式チャンネルでのみ参加可能となります:\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\nこの度の変更によりご不便をおかけし、誠に申し訳ございません。ご主人様の変わらぬご支援とご理解に心より感謝申し上げます。'
    }
  },
  methods: {
    // 检查是否在展示时间范围内
    isInDisplayPeriod(startTime, endTime) {
      const now = new Date()
      const startDate = new Date(startTime)
      const endDate = new Date(endTime)
      return now >= startDate && now <= endDate
    },
    // 获取当前UTC日期字符串 (YYYY-MM-DD)
    getCurrentUTCDateString() {
      const now = new Date()
      return now.toISOString().split('T')[0]
    },
    // 检查今天是否已经弹出过
    hasShownToday(cookieName) {
      const today = this.getCurrentUTCDateString()
      const lastShownDate = globalConfig.getCookie(cookieName)
      return lastShownDate === today
    },
    // 检查是否应该显示弹窗（每日一次，总共最多3次）
    shouldShowPopupWithLimit(
      startTime,
      endTime,
      dateCookieName,
      countCookieName,
      maxCount = 3
    ) {
      // 1. 检查是否在展示时间范围内
      if (!this.isInDisplayPeriod(startTime, endTime)) {
        return false
      }

      // 2. 检查今天是否已经弹出过
      if (this.hasShownToday(dateCookieName)) {
        return false
      }

      // 3. 检查总弹出次数是否达到上限
      const totalCount = parseInt(
        globalConfig.getCookie(countCookieName) || '0'
      )
      if (totalCount >= maxCount) {
        return false
      }

      return true
    },
    // 记录今天已经弹出
    markAsShownToday(cookieName) {
      const today = this.getCurrentUTCDateString()
      globalConfig.setCookie(cookieName, today)
    },
    // 记录弹出并增加计数
    markAsShownTodayWithCount(dateCookieName, countCookieName) {
      // 记录今天已弹出
      this.markAsShownToday(dateCookieName)

      // 增加总计数
      const currentCount = parseInt(
        globalConfig.getCookie(countCookieName) || '0'
      )
      globalConfig.setCookie(countCookieName, (currentCount + 1).toString())
    },
    showTipPopupEntry() {
      try {
        this.dzgjpDownThirdPartyPaymentTip()
      } catch (e) {
        console.error(e)
      }
    },
    dzgjpDownCouponTip() {
      if (
        this.isInDisplayPeriod(
          '2025-10-30T17:00:00+08:00',
          '2025-11-13T23:59:59+08:00'
        ) &&
        window.gameId == 209
      ) {
        if (
          this.isInDisplayPeriod(
            '2025-10-30T17:00:00+08:00',
            '2025-11-06T23:59:59+08:00'
          )
        ) {
          //  每次进来都弹出
          this.$store.commit('updateCommonTips', {
            content: this.dzgjpCouponDownContent,
            sure: ''
          })
        } else {
          const dateCookieName = `dzg_jp_coupon_down_${window.gameId}_mark`
          const countCookieName = `dzg_jp_coupon_down_${window.gameId}_count`

          if (
            this.shouldShowPopupWithLimit(
              '2025-11-07T00:00:00+08:00',
              '2025-11-13T23:59:59+08:00',
              dateCookieName,
              countCookieName,
              15
            )
          ) {
            this.$store.commit('updateCommonTips', {
              content: this.dzgjpCouponDownContent,
              sure: ''
            })
            this.markAsShownTodayWithCount(dateCookieName, countCookieName)
          }
        }
      }
    },
    dzgjpDownThirdPartyPaymentTip() {
      if (
        this.isInDisplayPeriod(
          '2025-11-24T11:00:00+09:00',
          '2025-12-31T23:59:59+09:00'
        ) &&
        window.gameId == 209
      ) {
        const dateCookieName = `dzg_jp_third_party_payment_down_${window.gameId}_mark`;
        const countCookieName = `dzg_jp_third_party_payment_down_${window.gameId}_count`;
        if (
          this.shouldShowPopupWithLimit(
            '2025-11-24T11:00:00+09:00',
            '2025-12-31T23:59:59+09:00',
            dateCookieName,
            countCookieName,
            100000
          )
        ) {
          this.$store.commit('updateCommonTips', {
            content: this.dzgjpThirdPartyPaymentDownContent,
            sure: ''
          })
          this.markAsShownTodayWithCount(dateCookieName, countCookieName);
        }
      }
    }
  }
}
